// src/exerciseVideos.js

export const EXERCISE_VIDEO_MAP = {
  // --- POWERHOUSE / SUPER SOLDIER COMPOUNDS & BIG LIFTS ---
  "Barbell Bench Press": "https://www.youtube.com/watch?v=vthMCtgVtFw",
  "Bench Press": "https://www.youtube.com/watch?v=vthMCtgVtFw",
  "Back Squat": "https://www.youtube.com/watch?v=Qif41V01Jaw",
  "Deadlift (Conventional or Sumo)":
    "https://www.youtube.com/watch?v=ytGaGIn3SjE",
  Deadlift: "https://www.youtube.com/watch?v=ytGaGIn3SjE",
  "Front Squat": "https://www.youtube.com/watch?v=7xyyb_nIZg8",
  "Romanian Deadlift": "https://www.youtube.com/watch?v=2SHsk9AzdjA",
  "Romanian Deadlifts": "https://www.youtube.com/watch?v=2SHsk9AzdjA",
  "Romanian Deadlifts or Single-Leg RDLs":
    "https://www.youtube.com/watch?v=2SHsk9AzdjA",
  "Hip Thrusts (Barbell or Machine)":
    "https://www.youtube.com/watch?v=S_uZP4UH6J0",
  "Good Mornings": "https://www.youtube.com/watch?v=rW0ymK1k5_4",

  // --- PULLING / ROWS / BACK ---
  "Weighted Pull-Ups": "https://www.youtube.com/shorts/XtwelwPhcaw",
  "Pull-Ups (Various Grips)": "https://www.youtube.com/watch?v=rn1w4MRHP3E",
  "Pull-Ups / Chin-Ups": "https://www.youtube.com/watch?v=rn1w4MRHP3E",
  "Chin-Ups (Band Assisted if needed)":
    "https://www.youtube.com/watch?v=rn1w4MRHP3E",
  "Dead Hangs / Grip Holds": "https://www.youtube.com/shorts/XPcT3capkyk",
  "Inverted Rows (Feet Elevated if strong)":
    "https://www.youtube.com/shorts/vZy_Eu_Z0WA",
  "Lat Pulldown / Pull-Ups": "https://www.youtube.com/watch?v=OcFCHdQHjVU",
  "Face Pulls": "https://www.youtube.com/shorts/n9iyonvnuFc",

  "One-Arm DB Row": "https://www.youtube.com/watch?v=_NjSOXXwBOQ",
  "Single-Arm DB Row": "https://www.youtube.com/watch?v=_NjSOXXwBOQ",
  "Seated Cable Row or Chest-Supported Row":
    "https://www.youtube.com/watch?v=7BkgqzC6WsM",
  "Chest-Supported Row": "https://www.youtube.com/watch?v=kBWAon7ItDw",
  "Barbell or Machine Row": "https://www.youtube.com/watch?v=kBWAon7ItDw",
  "Cable Row": "https://www.youtube.com/watch?v=7BkgqzC6WsM",

  // --- PRESSING / SHOULDERS / ARMS ---
  "Incline DB Bench Press": "https://www.youtube.com/watch?v=PUrfhmHszU8",
  "Incline DB Press": "https://www.youtube.com/watch?v=PUrfhmHszU8",
  "Incline Bench Press": "https://www.youtube.com/watch?v=PUrfhmHszU8",

  "Overhead Press": "https://www.youtube.com/watch?v=Gu1t7X2yq4M",
  "Overhead Press or Push Press": "https://www.youtube.com/watch?v=Gu1t7X2yq4M",
  "Standing DB Shoulder Press": "https://www.youtube.com/watch?v=Z2kbEJMyt10",
  "DB Shoulder Press": "https://www.youtube.com/watch?v=Z2kbEJMyt10",
  "Seated DB Shoulder Press": "https://www.youtube.com/watch?v=Z2kbEJMyt10",

  "Weighted Dips": "https://www.youtube.com/watch?v=BjiyWC_cJW0",
  "Ring or Bar Dips": "https://www.youtube.com/watch?v=BjiyWC_cJW0",

  "Push-Ups (Weighted or Deficit)":
    "https://www.youtube.com/watch?v=-Mbr55h3BeQ",
  "Pike Push-Ups / Handstand Push-Up Progressions":
    "https://www.youtube.com/shorts/gSjHRuRQ4hk",
  "Push-Up Variations (Deficit or Feet Elevated)":
    "https://www.youtube.com/watch?v=-Mbr55h3BeQ",
  "Push-Up Variations": "https://www.youtube.com/watch?v=-Mbr55h3BeQ",
  "Push-Ups": "https://www.youtube.com/watch?v=-Mbr55h3BeQ",
  "Diamond or Close-Grip Push-Ups":
    "https://www.youtube.com/watch?v=-Mbr55h3BeQ",

  "Barbell / EZ-Bar Curls": "https://www.youtube.com/watch?v=KS-1_r9K4XA",
  "Barbell / DB Curls (Heavy)": "https://www.youtube.com/watch?v=KS-1_r9K4XA",
  "Barbell or DB Curls": "https://www.youtube.com/watch?v=KS-1_r9K4XA",
  "Biceps Curls (Barbell or Rings)":
    "https://www.youtube.com/watch?v=KS-1_r9K4XA",
  "Barbell Curls": "https://www.youtube.com/watch?v=KS-1_r9K4XA",
  "Hammer Curls": "https://www.youtube.com/shorts/E0fhqFK3agg",
  "Cable Curls": "https://www.youtube.com/watch?v=KS-1_r9K4XA",

  "Skullcrushers or Cable Overhead Extensions":
    "https://www.youtube.com/watch?v=pEICum-puRU",
  "Cable Triceps Pressdowns": "https://www.youtube.com/watch?v=6yp_-GcB4ew",
  "Overhead Triceps Extensions": "https://www.youtube.com/watch?v=aR9I7q2wR8o",

  // --- ISOLATION / ACCESSORY ---
  "Cable Flyes": "https://www.youtube.com/watch?v=8Um35Es-ROE",
  "Straight-Arm Pulldown": "https://www.youtube.com/watch?v=WDOV2PDpkiU",
  "Lateral Raises": "https://www.youtube.com/watch?v=ozpcrgmwyto",
  "DB Lateral Raises": "https://www.youtube.com/watch?v=ozpcrgmwyto",
  "Rear Delt Flyes": "https://www.youtube.com/watch?v=3eOFjmSM9s8",
  "Reverse Flyes": "https://www.youtube.com/watch?v=3eOFjmSM9s8",

  "Leg Press": "https://www.youtube.com/shorts/TiUJA6Hunr0",
  "Leg Press (Glute-Biased Foot Position)":
    "https://www.youtube.com/shorts/TiUJA6Hunr0",
  "Leg Curl": "https://www.youtube.com/watch?v=PtmNn03p3hU",
  "Leg Curl (Lying or Seated)": "https://www.youtube.com/watch?v=PtmNn03p3hU",

  "Standing Calf Raise": "https://www.youtube.com/watch?v=c5Kv6-fnTj8",
  "Standing or Seated Calf Raises":
    "https://www.youtube.com/watch?v=c5Kv6-fnTj8",

  "Abduction Machine / Band Walks":
    "https://www.youtube.com/watch?v=OjI5OpV6IWA",
  "Cable/Band Hip Abductions": "https://www.youtube.com/watch?v=cz1gh_aYn5k",
  "Cable Kickbacks": "https://www.youtube.com/watch?v=f0BJ2iCphow",

  "Back Extensions (Glute Focus)":
    "https://www.youtube.com/watch?v=ZlY9Y_nQ2V8",
  "Reverse Hyper (if available) or Hip Extensions":
    "https://www.youtube.com/watch?v=ZlY9Y_nQ2V8",
  "Cable Woodchops": "https://www.youtube.com/watch?v=pAplQXk3dkU",

  // --- CORE / ABS / CARRIES ---
  "Hanging Leg Raises": "https://www.youtube.com/watch?v=Pr1ieGZ5atk",
  "Hanging Leg Raises or Ab Wheel":
    "https://www.youtube.com/watch?v=Pr1ieGZ5atk",
  "Hanging Leg Raises or Toe-to-Bar":
    "https://www.youtube.com/watch?v=Pr1ieGZ5atk",
  "Hanging Leg Raises / Windshield Wipers":
    "https://www.youtube.com/watch?v=Pr1ieGZ5atk",

  "Plank Variations": "https://www.youtube.com/watch?v=xVrALzPc7dM",
  "Core Circuit (Planks, Dead Bugs, Side Planks)":
    "https://www.youtube.com/watch?v=xVrALzPc7dM",
  "Core Circuit (Planks, Leg Raises, Crunches)":
    "https://www.youtube.com/watch?v=qk97w6ZmV90",
  "Core Mixed (Leg Raises, Cable Crunches, Obliques)":
    "https://www.youtube.com/watch?v=TqXwI1MWZks",
  "Core Stability Circuit": "https://www.youtube.com/watch?v=IWxerVP5eps",
  "Core Finisher (Heavy Carries / Russian Twists etc.)":
    "https://www.youtube.com/watch?v=IWxerVP5eps",
  "Core Finisher (Planks / Leg Raises / Anti-Rotation)":
    "https://www.youtube.com/watch?v=xVrALzPc7dM",

  "Cable Crunches": "https://www.youtube.com/watch?v=TYS5ewGQcYQ",
  "Dead Bugs": "https://www.youtube.com/watch?v=0XVbn86Btj0",
  "Bird Dogs": "https://www.youtube.com/watch?v=0BSMXVLd_Ls",
  "Side Planks": "https://www.youtube.com/watch?v=bGAL_IpBA2o",
  "Russian Twists": "https://www.youtube.com/shorts/R7a7jO6d3HU",

  "Weighted Carries": "https://www.youtube.com/watch?v=IWxerVP5eps",
  "Farmer’s Carries": "https://www.youtube.com/watch?v=IWxerVP5eps",

  // --- LEGS / UNILATERAL / ATHLETIC ---
  "Walking Lunges": "https://www.youtube.com/watch?v=Q59ZvPhpySM",
  "Bulgarian Split Squats": "https://www.youtube.com/watch?v=2C-uNgKwPLE",
  "Goblet Squats": "https://www.youtube.com/watch?v=MeIiIdhvXT4",
  "Reverse Lunges": "https://www.youtube.com/watch?v=Q59ZvPhpySM",

  // --- CONDITIONING / SPRINTS / JUMPS ---
  "Optional: Sled Push / Battle Ropes":
    "https://www.youtube.com/watch?v=BnGvgbDzheQ",
  "Sled Push or Bike/Row Sprints":
    "https://www.youtube.com/watch?v=BnGvgbDzheQ",
  "Bike Sprints": "https://www.youtube.com/watch?v=FpE7TbADcYs",
  "Bike or Row Sprints": "https://www.youtube.com/watch?v=FpE7TbADcYs",
  "Row/Bike/Run Intervals": "https://www.youtube.com/watch?v=FpE7TbADcYs",
  "Short Conditioning Circuit": "https://www.youtube.com/watch?v=NqvooBJ8FY8",
  "Short Sprints (40–60m)": "https://www.youtube.com/watch?v=K6ZyvGh54bA",
  "Tempo Runs or Shuttle Sprints":
    "https://www.youtube.com/watch?v=ArRmzy_ckOQ",
  "Jog / Easy Run": "https://www.youtube.com/watch?v=entUXhcgt3c",
  "Optional: Easy Run / Walk": "https://www.youtube.com/watch?v=entUXhcgt3c",

  "Jump Rope": "https://www.youtube.com/watch?v=cVimHHzfP9g",
  "Box Jumps": "https://www.youtube.com/watch?v=LK-pAoXhQNQ",
  "Box Jumps or Broad Jumps": "https://www.youtube.com/watch?v=LK-pAoXhQNQ",
  "Box Jumps / Tuck Jumps": "https://www.youtube.com/watch?v=LK-pAoXhQNQ",
  "Agility / Ladder Drills": "https://www.youtube.com/watch?v=ucHoBr6qlZY",

  "Hip & Ankle Mobility Flow": "https://www.youtube.com/watch?v=7dT4KHtMM-A",
  "Extended Mobility & Stretching":
    "https://www.youtube.com/watch?v=7dT4KHtMM-A",
  "Full-Body Mobility (Hips, Ankles, Shoulders)":
    "https://www.youtube.com/watch?v=m4-MLaa4nCs",

  // --- ONE PUNCH 100S ---
  "Bodyweight Squats": "https://www.youtube.com/watch?v=MeIiIdhvXT4",
  "Sit-Ups / Crunches": "https://www.youtube.com/watch?v=TqXwI1MWZks",

  // --- MISC CIRCUITS & SPECIALS ---
  "Circuit: Push-Ups, Air Squats, Sit-Ups":
    "https://www.youtube.com/watch?v=s0m2K_40G6A",
};
